/**
 * Per-user Backstage feature flag that gates the "expected to be patched" UI:
 * the finding-summary chip, the due-date status text, and the "Expected
 * Remediation Via Patch" checkbox/count on the Actions dashboard.
 *
 * The due-date text itself is computed server-side in
 * nvmDataFetchCheckHandler.ts, which runs on a schedule with no per-user
 * context, so it can't be flag-aware at the source. Instead, the frontend
 * detects that text via `isExpectedPatchText` (data-table/utils/date.ts) and
 * substitutes the normal "N days overdue" wording when this flag is off.
 *
 * Namespaced with the `ys-` prefix per convention (see {@link ZERO_DAY_FLAG_KEY}).
 * Registered in the yardstick-react plugin `featureFlags` array so it appears
 * in `/settings/feature-flags` at app bootstrap (OFF by default for all users,
 * including admins).
 */
export const EXPECTED_PATCHES_FLAG_KEY = 'ys-expected-patches';
